import React, { forwardRef, Ref } from 'react';

import { IconTypes } from '@eika/icon';

import Button from '../Button';
import { ButtonSizes, IconButtonTypes } from '../ButtonTypes';
import { SharedButtonProps } from '../Props';

interface IconButtonProps extends Omit<SharedButtonProps<IconButtonTypes>, 'icon' | 'size'> {
    icon: IconTypes;
    // @default 'standard'
    size?: Exclude<ButtonSizes, 'large'>;
    screenReaderText: string;
}

const IconButton = forwardRef(
    (
        { icon, screenReaderText, buttonType = 'icon', ...rest }: IconButtonProps,
        ref: Ref<HTMLButtonElement>,
    ): JSX.Element => {
        return (
            <Button {...rest} buttonType={buttonType} icon={icon} ref={ref}>
                <span className="screen-reader-text">{screenReaderText}</span>
            </Button>
        );
    },
);

export default IconButton;
